import { makeStyles } from '@material-ui/core/styles';

// marginBottom, viewColumn, label,
//textContent, label, textContent, textSubItems, onlyMarginLeft

export const useStyles = makeStyles((theme) => ({
  textContent: { fontSize: 18, color: '#202020', fontWeight: 'bold' },
  label: { fontSize: 15, color: '#ACABB9' },
  viewColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10,
  },
  marginBottom: { marginBottom: 10 },
  marginTop: { marginTop: 10 },
}));
